/** Full-page navigation (e.g. to Keycloak); isolated so specs can observe it. */
export function navigateToExternal(url: string): void {
  window.location.assign(url);
}
